import {LocationQuery} from 'vue-router'
import {GUEST_THEME_QUERY_PARAM} from '@toolify/server/src/services/UserSettingsService/constants/guestAppearanceConstants'

function toSingleQueryValue(value: unknown): string | undefined {
  if(Array.isArray(value)) {
    return typeof value[0] === 'string' && value[0] ? value[0] : undefined
  }
  if(typeof value === 'string' && value) {
    return value
  }
  return undefined
}

function getThemeFromSearch(search: string): string | undefined {
  const value = new URLSearchParams(search).get(GUEST_THEME_QUERY_PARAM)
  return value || undefined
}

export function getGuestThemeQueryValue(query?: LocationQuery): string | undefined {
  const fromQuery = toSingleQueryValue(query?.[GUEST_THEME_QUERY_PARAM])
  if(fromQuery) {
    return fromQuery
  }
  if(typeof window === 'undefined') {
    return undefined
  }
  const fromSearch = getThemeFromSearch(window.location.search)
  if(fromSearch) {
    return fromSearch
  }
  const hash = window.location.hash
  const queryIndex = hash.indexOf('?')
  if(queryIndex === -1) {
    return undefined
  }
  return getThemeFromSearch(hash.slice(queryIndex))
}
